import MyAccount from './MyAccount.container';

export default MyAccount;
